import Mock from 'mockjs';
Mock.setup({
    timeout: 500
});

Mock.mock('/api/growth/home/getHomePageInfo', ({ url, type, body }) => {
    console.log(`'${url}' by '${type}'\t\tparams is:${body}`);
    return {
        Result: 200,
        resultMessage: '成功',
        Content: 2
    };
});

Mock.mock('/api/growth/award/getbirthdaycouponpageinfo', ({ url, type, body }) => {
    console.log(`'${url}' by '${type}'\t\tparams is:${body}`);
    return {
        Result: 200,
        ResultMessage: '成功',
        Content: {
            level: 'V1',
            requiredLevel: 'V1',
            receiveStartTime: '2020-01-01',
            receiveEndTime: '2020-01-31',
            awardList: [
                {
                    awardKey: 'birthdaycoupon',
                    awardType: 0,
                    status: 0,
                    effectiveDays: 30,
                    couponAmount: 3000
                }
            ]
        }
    };
});

Mock.mock('/api/growth/home/foo', ({ url, type, body }) => {
    console.log(`'${url}' by '${type}'\t\tparams is:${body}`);
    return {
        Result: 200,
        resultMessage: '成功',
        Content: 'foo'
    };
});

Mock.mock('/api/growth/home/getBubbleScoreList', ({ url, type, body }) => {
    console.log(`'${url}' by '${type}'\t\tparams is:${body}`);
    return {
        'Result': 200,
        'ResultMessage': '成功',
        'CodeMsg': null,
        'Content': {
            'timestamp': 131000000000,
            'marketingBubbleNode': 2,
            'bubbleScoreList': [
                {
                    'id': 1212,
                    'taskId': 201,
                    'score': 5,
                    'title': '手机充值',
                    'bubbleType': 0,
                    'bubbleIcon': '/xxxx',
                    'exposureDaysTillYesterday': null,
                    'exposureDaysTillToday': null,
                    'desc': null,
                    'buttonText': null,
                    'redirectUrl': null,
                    'taskHandler': null,
                    'countDown': null,
                    'afterRewardScore': 5
                },
                {
                    'id': 1212,
                    'taskId': 202,
                    'score': 10,
                    'title': '信用卡还款',
                    'bubbleType': 0,
                    'bubbleIcon': '/xxxx',
                    'exposureDaysTillYesterday': null,
                    'exposureDaysTillToday': null,
                    'desc': null,
                    'buttonText': null,
                    'redirectUrl': null,
                    'taskHandler': null,
                    'countDown': null,
                    'afterRewardScore': 10
                },
                {
                    'id': 1214,
                    'taskId': 501,
                    'score': 1,
                    'title': '新人福利',
                    'bubbleType': 0,
                    'bubbleIcon': '/xxxx',
                    'exposureDaysTillYesterday': 2,
                    'exposureDaysTillToday': 3,
                    'desc': null,
                    'buttonText': null,
                    'redirectUrl': null,
                    'taskHandler': null,
                    'countDown': null,
                    'afterRewardScore': 1
                },
                {
                    'id': 1212,
                    'taskId': 202,
                    'score': 10,
                    'title': '完成借款',
                    'bubbleType': 1,
                    'bubbleIcon': '/xxxx',
                    'exposureDaysTillYesterday': null,
                    'exposureDaysTillToday': null,
                    'desc': '完成借款后获取...',
                    'buttonText': '去借款',
                    'redirectUrl': 'http://xxxx',
                    'taskHandler': 'YQuanTaskHandler',
                    'countDown': 13100000000,
                    'afterRewardScore': 10
                }
            ],
            'scoreInfo': {
                'totalScore': 300,
                'allScore': 350,
                'differenceOfNextLockScore': 60,
                'upgradeProgress': 30
            },
            'scoreExpireTips': {
                'expiringScore': 20
            }
        }
    };
});
